import React from "react";
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
import { Print } from "./Print"
import { useMaintenanceModel } from "../maintenanceModel";
import { ScaniaPrints } from "./scaniaPrint"
import { SettleScaniaPrints } from "./settleScaniaPrints"
import { PrintMaintenanceTable } from "./PrintMaintenanceTable"
import { PrintMaintenanceSettle } from "./PrintMaintenanceSettle"


export default () => {
    const {
        print,
        scaniaPrint: { visible },
        settleScaniaPrint,
        printVisible, setPrintVisible,
        printSettleVisible, setPrintSettleVisible,
        printParam, descRows
    } = useMaintenanceModel();

    return (
        <>
            <PageHeader />
            <DataBox />
            {print && <Print />}
            {visible && <ScaniaPrints />}
            {settleScaniaPrint && <SettleScaniaPrints />}
            {printVisible && <PrintMaintenanceTable printVisible={printVisible} setPrintVisible={setPrintVisible} printParam={printParam} />}
            {printSettleVisible && <PrintMaintenanceSettle printSettleVisible={printSettleVisible} setPrintSettleVisible={setPrintSettleVisible} printParam={printParam} selectRows={descRows} />}
        </>
    )
}